import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { UserModel } from '../../../_models/_index';
import { GeneralService, UserService } from '../../../services/_index';
import { AlertDialogTypeEnum, ViewModeEnum} from '../../../_enums/_index';
//import { AlertDialogComponent } from '../../alert-dialog/alert-dialog.component';
import { UsersDialogComponent } from '../users-dialog/users-dialog.component';

@Component({
    selector: 'app-users-grid',
    templateUrl: './users-grid.component.html',
    styleUrls: ['./users-grid.component.css']
})
export class UsersGridComponent implements OnInit {

    users: UserModel[];
    currentUser: UserModel;

    constructor(private usersService: UserService,
        private dialog: MatDialog,
        private generalService: GeneralService) {
        this.users = [];
        this.currentUser = this.usersService.getCurrentUser();
    }

    ngOnInit() {
        this.loadData();
    }

    loadData() {
        this.usersService.getUsers().then(result => {
            this.users = result;
        });
    }

    openAddDialog() {
        let dialogRef = this.dialog.open(UsersDialogComponent);
        dialogRef.disableClose = true;
        dialogRef.componentInstance.dialogHeader = 'הוספת משתמש';
        dialogRef.componentInstance.viewMode = ViewModeEnum.Add;

        dialogRef.afterClosed().subscribe((result: UserModel) => {
            if (result) {
                result;
                let copy = Object.assign([], this.users);
                copy.push(result);
                this.users = copy;
                this.generalService.showSnackBar("הוספת משתמש התבצעה בהצלחה!");
            }
        });
    }

    openEditDialog(user: UserModel) {
        let dialogRef = this.dialog.open(UsersDialogComponent);
        dialogRef.disableClose = true;
        dialogRef.componentInstance.dialogHeader = 'עריכת משתמש';
        dialogRef.componentInstance.viewMode = ViewModeEnum.Edit;
        let model2edit: UserModel = new UserModel();
        model2edit = Object.assign({}, <UserModel>user);
        dialogRef.componentInstance.user = model2edit;

        dialogRef.afterClosed().subscribe((result: UserModel) => {
            if (result) {
                let copy = Object.assign([], this.users);
                copy.splice(this.users.findIndex(o => o.id == result.id), 1, result);
                this.users = copy;
                this.generalService.showSnackBar("עריכת משתמש התבצעה בהצלחה!");
            }
        });
    }

    removeUser(user: UserModel) {
        let message = "האם אתה בטוח שברצונך למחוק משתמש " + user.userName + "?";
        this.generalService.showConfirmDialog(message).then(result => {
            if (result) {
                this.usersService.removeUser(user).then(res => {
                    if (res) {
                        let copy = Object.assign([], this.users);
                        copy.splice(this.users.findIndex(o => o.id == user.id), 1);
                        this.users = copy;
                        this.generalService.showSnackBar("משתמש הוסר בהצלחה!");
                    }
                });
            }
            else {
                this.generalService.showSnackBar("מחיקה בוטלה");
            }
        });
    }   

    unBlockUser(user: UserModel) {
        let message = "האם אתה בטוח שברצונך לבטל חסימה למשתמש  " + user.userName + "?";
        this.generalService.showConfirmDialog(message).then(result => {
            if (result) {
                this.usersService.unBlockUser(user.id).then(res => {
                    if (res) {
                        let copy = Object.assign([], this.users);
                        copy.splice(this.users.findIndex(o => o.id == user.id), 1,res);
                        this.users = copy;
                        this.generalService.showSnackBar("ביטול חסימה התבצע בהצלחה!");
                    }
                });
            }
            else {
                this.generalService.showSnackBar("פעולה בוטלה");
            }
        });
    }  

    hasPermission2UnblockUsers() {
        return this.currentUser.canUnBlockUsers;
    } 
}



// WEBPACK FOOTER //
// ./src/app/components/users/users-grid/users-grid.component.ts